import instance from "./axios";

/**
 * Fetches EL image by either trackingNumber or serialNumber
 * @param paramType "trackingNumber" or "serialNumber"
 * @param value Value to use for the query
 * @param imageType Default: "backside"
 */
export async function fetchElImageBlob({
  paramType,
  value,
  imageType = "backside",
}: {
  paramType: "trackingNumber" | "serialNumber";
  value: string;
  imageType?: string;
}): Promise<Blob> {
  const response = await instance.get(
    `/api/mesbackend/Eldata/GetElImageByTrackingNumberOrSerialNumber`,
    {
      params: {
        imageType,
        [paramType]: value,
      },
      responseType: "blob",
    }
  );
  return response.data;
}
